import React, {Component} from 'react';
import {Button, ControlLabel, Form, FormControl, FormGroup, Glyphicon} from 'react-bootstrap';
import {Auth} from 'aws-amplify/lib/index';
import validator from 'validator';
import ErrorComponent from '../ErrorComponent';
import {Redirect} from 'react-router';

class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      error: null,
      sendingCode: false,
      sent: false
    };
  }

  validateForm = () => {
    return this.state.email.length > 0 && validator.isEmail(this.state.email);
  };

  handleChange = event => {
    this.setState({[event.target.id]: event.target.value});
  };

  handleSubmitEmail = async event => {
    event.preventDefault();
    this.setState({ sendingCode: true });
    try {
      await Auth.forgotPassword(this.state.email);
      this.setState({ error: null, sendingCode: false, sent: true });
    } catch (e) {
      let error = [{ code: e.code, msg: 'Error sending code. Please try again later.' }];
      switch (e.code) {
        case 'UserNotFoundException':
          error[0].msg = 'Email not found.';
          break;
        default:
          break;
      }
      this.setState({ sendingCode: false, error });
    }
  };

  render() {
    if (this.state.sent) {
      return <Redirect to='/reset'/>;
    }

    return (
      <div>
        { this.state.error &&
        <ErrorComponent error={this.state.error}/>
        }
        <h2 className='ta-center'>Forgot Password</h2>
        <Form className='max-width' onSubmit={this.handleSubmitEmail}>
          <FormGroup controlId="email" bsSize="large">
            <ControlLabel>Email: </ControlLabel>
            <FormControl
              data-cy="forgot-pwd-email"
              autoFocus={true}
              type="email"
              placeholder='Email'
              value={this.state.email}
              onChange={this.handleChange}/>
          </FormGroup>
          <Button
            data-cy="send-pwd-forgot-button"
            block
            bsSize="large"
            disabled={!this.validateForm() || this.state.sendingCode}
            type="submit">
            { this.state.sendingCode ? 'Loading...  ' : 'Send Reset Code' }
            { this.state.sendingCode && <Glyphicon glyph="refresh" className="spinning" /> }
          </Button>
        </Form>
      </div>
    );
  }
}

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/components/user/ForgotPassword.js